exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".homework[data-v-a15cd196]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;flex-direction:column;align-items:center;max-width:600px}.homework[data-v-a15cd196],.homework__auto[data-v-a15cd196],.homework__list[data-v-a15cd196]{width:100%}.homework__list[data-v-a15cd196]{padding:0;margin:0;list-style:none}", ""]);

// exports
